import { make } from "vuex-pathify";
import { getAPI, postAPI } from "@/store/restAPI.js";//eslint-disable-line

// initial state
const state = {
  loading: false,
};

// getters
const getters = {};

// actions
const actions = {

  retrieveSuppliers({ commit }) {
    commit("SET_LOADING", true);
    return getAPI("supplier/retrieveSuppliers").then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveSuppliersBySearch({ commit } , filter) {
    commit("SET_LOADING", true);
    return getAPI("supplier/retrieveSuppliersBySearch" , filter).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  deleteSupplier({ commit } , id) {
    commit("SET_LOADING", true);
    return postAPI("supplier/deleteSupplier/" + id).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveSupplierById({ commit }, id) {
    commit("SET_LOADING", true);
    return getAPI("supplier/retrieveSupplierById" , id)
      .then((response) => {
        return response;
      })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  saveSupplier({ commit }, supplier) {
    commit("SET_LOADING", true);
    return postAPI("supplier/saveSupplier", supplier).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  countSuppliers({ commit }) {
    commit("SET_LOADING", true);
    return getAPI("supplier/count").then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },


};

// mutations
const mutations = {
  ...make.mutations(state)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};